import { parseQuery } from '@/utils'

// 检测微信浏览器
export function isWeChatBrowser() {
  return /MicroMessenger/i.test(navigator.userAgent)
}

// 生成UUID格式的用户标识
export function generateUserId() {
  return 'uuid_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9)
}

// 获取或创建用户标识（核心方法）
export function getOrCreateUserId() {
  let userId = localStorage.getItem('openId')
  if (userId && userId !== 'null' && userId !== 'undefined') {
    return userId
  }

  // 检查URL参数（微信OAuth回调带openid）
  const query = parseQuery()
  if (query.openid) {
    localStorage.setItem('openId', query.openid)
    return query.openid
  }

  // 微信环境但无openid → 跳转OAuth
  if (isWeChatBrowser()) {
    window.location.href = 'https://science.warnny.com/fulongApi/wechat/authorize'
    return null
  }

  // 非微信环境 → 生成UUID
  const uuid = generateUserId()
  localStorage.setItem('openId', uuid)
  return uuid
}
